// extracted by mini-css-extract-plugin
export default {"container":"Home_container__HLpTt","list":"Home_list__BY8iX"};